import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../sitewide/Button'
import EmailBodyEditor from '../EmailBodyEditor'
import PlainTextEditor from '../PlainTextEditor'

import './styles.css'

class ExistingPatientMessageEditor extends React.Component {
  static propTypes = {
    handleSave: PropTypes.func,
    isEmail: PropTypes.bool,
  }

  state = {
    textChange: false,
  }

  saveMessageSetting = () => {
    const { handleSave } = this.props
    this.setState({ textChange: false })
    handleSave()
  }

  updateTextChange = (newState, oldState) => {
    const { textChange } = this.state
    const sameContent =
      newState.getCurrentContent() === oldState.getCurrentContent()
    if (!sameContent && !textChange) {
      this.setState({ textChange: true })
    }
  }

  subjectUpdate = newEditorState => {
    const { subjectState, updateSubjectState } = this.props
    this.updateTextChange(newEditorState, subjectState)
    updateSubjectState(newEditorState)
  }

  bodyUpdate = newEditorState => {
    const { bodyState, updateBodyState } = this.props
    this.updateTextChange(newEditorState, bodyState)
    updateBodyState(newEditorState)
  }

  render() {
    const { bodyState, subjectState } = this.props
    const { textChange } = this.state

    const validEmail = bodyState.getCurrentContent().hasText() &&
        subjectState.getCurrentContent().hasText()
    const saveDisabled = !textChange || !validEmail

    return (
      <div className="singleMessageContainer CallTextSettingEditor">
        <div className="editorWrapper">
          <PlainTextEditor
            {...this.props}
            updateSubjectState={this.subjectUpdate}
          />
          <div className="bodyEditor">
            <EmailBodyEditor
              {...this.props}
              updateBodyState={this.bodyUpdate}
            />
            <div className="buttonWrapper">
              <Button
                disabled={saveDisabled}
                onClick={this.saveMessageSetting}
                paddingTB="7px"
                paddingLR="30px"
              >
                {textChange ? 'Save' : 'Saved'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ExistingPatientMessageEditor



// WEBPACK FOOTER //
// ./src/components/Settings/ExistingPatientMessageEditor/ExistingPatientMessage.js